import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface BookingData {
  peopleCount: string
  placeId: string
  startDate: string
  endDate: string
  place: any
  city: string
  searchData?: {
    startDateString: string
    finishDateString: string
    timeStart: Date | null
    timeFinish: Date | null
    peopleCount: string
  }

  bookingType?: string
  fullName?: string
  phone?: string
  email?: string
  organizationName?: string
  inn?: string
  kpp?: string
  ogrn?: string
  address?: string
  contactPerson?: string
}

interface BookingTabsState {
  activeTab: number
  completedTabs: number[]
  selectedPlace: any | null
  bookingData: BookingData | null
  isBookingCreated: boolean
}

const initialState: BookingTabsState = {
  activeTab: 0,
  completedTabs: [],
  selectedPlace: null,
  bookingData: null,
  isBookingCreated: false,
}

const bookingTabsSlice = createSlice({
  name: 'bookingTabs',
  initialState,
  reducers: {
    setActiveTab: (state, action: PayloadAction<number>) => {
      state.activeTab = action.payload
    },
    setCompletedTabs: (state, action: PayloadAction<number[]>) => {
      state.completedTabs = action.payload
    },
    addCompletedTab: (state, action: PayloadAction<number>) => {
      if (!state.completedTabs.includes(action.payload)) {
        state.completedTabs.push(action.payload)
      }
    },
    setSelectedPlace: (state, action: PayloadAction<any>) => {
      state.selectedPlace = action.payload
    },
    resetBookingTabs: (state) => {
      state.activeTab = 0
      state.completedTabs = []
      state.selectedPlace = null
      state.bookingData = null
      state.isBookingCreated = false
    },
    nextTab: (state) => {
      if (state.activeTab < 4) {
        if (!state.completedTabs.includes(state.activeTab)) {
          state.completedTabs.push(state.activeTab)
        }
        state.activeTab += 1
      }
    },
    createBooking: (state, action: PayloadAction<BookingData>) => {
      state.bookingData = action.payload
      state.isBookingCreated = true

      if (!state.completedTabs.includes(state.activeTab)) {
        state.completedTabs.push(state.activeTab)
      }
      state.activeTab += 1
    },
    clearBooking: (state) => {
      state.bookingData = null
      state.isBookingCreated = false
    },
    saveBookingFormData: (state, action: PayloadAction<Partial<BookingData>>) => {
      if (state.bookingData) {
        state.bookingData = { ...state.bookingData, ...action.payload }
      } else {
        state.bookingData = action.payload as BookingData
      }
    },
    saveSearchData: (state, action: PayloadAction<BookingData['searchData']>) => {
      if (state.bookingData) {
        state.bookingData.searchData = action.payload
      } else {
        state.bookingData = {
          peopleCount: '',
          placeId: '',
          startDate: '',
          endDate: '',
          place: null,
          city: '',
          searchData: action.payload,
        }
      }
    },
  },
})

export const {
  setActiveTab,
  setCompletedTabs,
  addCompletedTab,
  setSelectedPlace,
  resetBookingTabs,
  nextTab,
  createBooking,
  clearBooking,
  saveBookingFormData,
  saveSearchData,
} = bookingTabsSlice.actions

export default bookingTabsSlice.reducer
